import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function PickList() {
  return <WarehouseOpsPage mode="pick" title="Pick List" subtitle="Identify packages to be collected for dispatch" />;
}
